import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BasePhotoWrapperComponent } from '@src/app/shared';
import { GetImageType } from '@src/models/images';

import { StoreService } from '../../services';

import { AvatarService } from './services';
import { PhotoInputType } from './types';

@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotoComponent extends BasePhotoWrapperComponent implements OnChanges {
  private readonly avatarService = inject(AvatarService);
  private readonly store = inject(StoreService);

  @Input({ required: true }) type?: PhotoInputType;

  // TODO: Использовать разные размеры после добавления размеров фото в мессенджере
  override getStorePhotoSrc(id: string, photoSize?: GetImageType): string | undefined {
    switch (this.type) {
      case 'user':
        return this.store.getUser(id).avatarSrc;

      case 'chat':
        return this.store.getChat(id).avatarSrc;

      default:
        return;
    }
  }

  override apiDelete(id: string): Observable<any> {
    switch (this.type) {
      case 'chat':
        return this.avatarService.deleteChatAvatar(id);

      default:
        return of(null);
    }
  }

  override getPhotoBlob(id: string, photoSize?: GetImageType): Observable<Blob | null> {
    switch (this.type) {
      case 'user':
        return this.avatarService.getUserAvatar(id);

      case 'chat':
        return this.avatarService.getChatAvatar(id);

      default:
        return of(null);
    }
  }
}
